import React, { useState } from "react";
import "./ModalIntroMs.css";
import { FormattedMessage, useIntl } from "react-intl";
import { Col, Row } from "react-bootstrap";
import GuideTemplate from "./GuideTemplate";
import CustomButton from "./PushButtonFilterMercadoShops";
import { Button } from "primereact/button";
import ButtonCommon from "./ButtonCommon";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ColumnSelectFitType from "../components-forms/ColumnSelectFitType";

interface ModalProps {
  closeModal: () => void;
  selectedLanguage: "es" | "en" | "pt";
  user: any;
}

const ModalIntroMs: React.FC<ModalProps> = ({
  closeModal,
  selectedLanguage,
  user,
}) => {
  const [step, setStep] = useState<number>(1);

  const languageImages = {
    es: "img/modalwelcome.png",
    en: "img/modalintrohello.png",
    pt: "img/modalintroola.png",
  };

  const handleNext = () => {
    setStep((prevStep) => prevStep + 1);
  };

  const handleExit = () => {
    closeModal();
  };

  const handleBegin = () => {
    closeModal();
  };

  const handleDotClick = (newStep: number) => {
    setStep(newStep);
  };

  const colStyle = {
    marginBottom: "30px",
  };

  const handleNothing = () => {};

  const intl = useIntl();

  const FitBodyTemplate = (product: any) => {
    return (
      <ColumnSelectFitType
        placeholder={
          <FormattedMessage id="ms-choose-fit" defaultMessage="Elegir Fit" />
        }
      />
    );
  };

  const productData = [
    {
      id: 1,
      image: "img/msshirtdemo.jpg",
      code: "ABC123",
      fit: "Regular",
    },
  ];

  return (
    <div className="modal">
      <div className="modal-intro-container">
        {step === 1 && (
          <div>
            <div className="modal-intro-titles-container">
              <p className="modal-intro-stepone-title">
                <>
                  <FormattedMessage
                    id="ready-size-ms-welcome"
                    defaultMessage="Bienvenidos "
                  />
                  {user && user.Name ? ` ${user.Name}` : ""}
                </>
              </p>
              <img
                src="img/welcomeballoon.png"
                alt="welcomeimage"
                className="ms-onboarding-stepone-img"
              />
              <p className="modal-intro-tour">
                <FormattedMessage
                  id="ready-size-ms-intro-text"
                  defaultMessage="Bienvenido! este es un tutorial para que aprendas a manejar nuestro administrador. Aquí encontrarás todos los pasos necesarios para sacar el máximo provecho de nuestras herramientas."
                />
              </p>
            </div>
            <div className="modal-intro-stepzero-buttons-container">
              <button
                className="modal-intro-stepzero-button-bg"
                onClick={handleNext}
              >
                <FormattedMessage
                  id="ready-size-ms-begin"
                  defaultMessage="Comenzar"
                />
              </button>
              <button
                className="modal-intro-stepzero-button-bg-close"
                onClick={handleExit}
              >
                <FormattedMessage
                  id="modal-intro-dont-watch"
                  defaultMessage="No Gracias"
                />
              </button>
            </div>
          </div>
        )}
        {step === 2 && (
          <div className="modal-intro-titles-container-two">
            <p className="modal-intro-stepone-title">
              <FormattedMessage
                id="ready-size-ms-steptwo-title"
                defaultMessage="Nuestra UI"
              />
            </p>
            <div className="ms-step-two-first-exp">
              <p className="ms-step-first-text">
                <FormattedMessage
                  id="table-modalintro-stepone-firsthelper"
                  defaultMessage="Estos botones te van a ayudar a encontrar tus productos no
                  clasificados y deshabilitados para asi poder darlos de alta mas
                  facilmente"
                />
              </p>
              <div className="ms-onboarding-step-two-btnclss-container">
                <CustomButton
                  messageId="ready-size-ms-noclasificado"
                  quantity="20"
                  onClick={handleNothing}
                />
                <CustomButton
                  messageId="ready-size-deshabilitado"
                  quantity="4"
                  onClick={handleNothing}
                />
                {/* <CustomButton
                  buttonText="No Clasificado"
                  quantity="20"
                  onClick={handleNothing}
                />
                <CustomButton
                  buttonText="Deshabilitado"
                  quantity="4"
                  onClick={handleNothing}
                /> */}
              </div>
            </div>
            <div className="ms-step-two-second-exp">
              <div className="ms-search-refresh-container">
                <img
                  src="img/mstooltipsearch.png"
                  alt="welcomeimage"
                  className="ms-tooltip-img"
                />
                <input
                  type="text"
                  // value={globalFilter}
                  // onChange={(e) => setGlobalFilter(e.target.value)}
                  placeholder={intl.formatMessage({
                    id: "ms-table-column-search",
                    defaultMessage: "Buscar producto...",
                  })}
                  className="p-inputtext p-component"
                />
              </div>
              <div>
                <p className="ms-onboard-textone">
                  <FormattedMessage
                    id="table-modalintro-stepone-secondhelper"
                    defaultMessage="Con este tooltip podes volver a ver el tutorial cuando te sea
                  necesario! Con nuestro buscador podes filtrar productos por su
                  numbre o codigo de guía."
                  />
                </p>
              </div>
            </div>
            <div className="ms-step-two-second-exp">
              <div className="ms-search-refresh-container">
                <p className="ms-onboard-texttwo">
                  <FormattedMessage
                    id="table-modalintro-stepone-thirdhelper"
                    defaultMessage="Para traer tus productos desde Mercado Shops, vas a tener que
                    usar el boton de Sync Marketplace, para ver tus cambios el
                    otro, podes tambien sincronizar productos individualmente, una vez que termines de clasificar tus productos no te
                    olvides de guardarlos!."
                  />
                </p>
              </div>
              <div>
                <div className="ms-step-two-search-refresh-container">
                  <div className="">
                    <button className="mssync-button">
                      <FormattedMessage
                        id="ready-size-sync"
                        defaultMessage="Sync Marketplace"
                      />
                    </button>
                    {/* <ButtonCommon
                      label={
                        <FormattedMessage
                          id="ready-size-sync"
                          defaultMessage="Sync Marketplace"
                        />
                      }
                      isOutline={false}
                      // eventClick={() => onClickSave()}
                    /> */}
                  </div>
                  <div className="ms-save-buttons">
                    <ButtonCommon
                      label={
                        <FormattedMessage
                          id="ready-size-ms-load"
                          defaultMessage="Guardar"
                        />
                      }
                      isOutline={false}
                      // onClick={() => onClickRefresh()}
                    />
                    <ButtonCommon
                      label={
                        <FormattedMessage
                          id="ready-size-Guardar"
                          defaultMessage="Guardar"
                        />
                      }
                      isOutline={false}
                      // eventClick={() => onClickSave()}
                    />
                  </div>
                  <div>
                    <Button
                      icon="pi pi-refresh"
                      className="ms-refresh-button"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="ms-modal-intro-stepone-button-container">
              {/* <button className="modal-intro-button-nobg" onClick={handleExit}>
                <FormattedMessage
                  id="ready-size-close"
                  defaultMessage="Salir"
                />
              </button> */}
              {/* <div className="modal-intro-dots">
                <span
                  className={step === 2 ? "active-dot" : "dot"}
                  onClick={() => handleDotClick(2)}
                ></span>
                <span className="dot" onClick={() => handleDotClick(3)}></span>
                <span className="dot" onClick={() => handleDotClick(4)}></span>
              </div> */}
              <button
                className="ms-modal-intro-button-bg-next-step-two"
                onClick={handleNext}
              >
                <FormattedMessage
                  id="readysize-next"
                  defaultMessage="Siguiente"
                />
              </button>
            </div>
          </div>
        )}
        {step === 3 && (
          <div className="modal-intro-titles-container-three">
            <p className="modal-intro-stepone-title">
              <FormattedMessage
                id="ready-size-ms-stepthree-title"
                defaultMessage="Alta de Guías"
              />
            </p>

            {/* <img src="img/inputsimg.png" alt="inputsimage" /> */}

            <div>
              <DataTable value={productData}>
                <Column
                  header={
                    <FormattedMessage
                      id="ms-table-column-image"
                      defaultMessage="Imagen"
                    />
                  }
                  body={(rowData: any) => (
                    <img
                      src={rowData.image}
                      alt="Product"
                      className="product-image"
                    />
                  )}
                />
                <Column
                  field="code"
                  header={
                    <FormattedMessage
                      id="ms-table-column-code"
                      defaultMessage="Código"
                    />
                  }
                  sortable
                />
                <Column
                  header={
                    <FormattedMessage
                      id="ms-table-column-fit"
                      defaultMessage="Calce"
                    />
                  }
                  body={FitBodyTemplate}
                />
              </DataTable>
              {/* <img
                src="img/mscheckinputs.png"
                alt="welcomeimage"
                className="ms-tooltip-img"
              />{" "} */}
              <p className="ms-stepthree-exp">
                <FormattedMessage
                  id="ready-size-ms-stepthree-firsthelper"
                  defaultMessage="Podes seleccionar varios productos en simultaneo y asignarles un
                codigo de guía o fit a todas al mismo tiempo, acordate de
                guardar tus cambios una vez que termines!"
                />
              </p>
              <div className="rs-step-three-tooltips-container">
                <h4 className="rs-habilitado-btn-h4">
                  <FormattedMessage
                    id="ready-size-ms-stepthree-secondhelper-title"
                    defaultMessage="Para tener en cuenta:"
                  />
                </h4>
                <div className="rs-tooltips-container">
                  <div>
                    <p className="rs-classified-btn">
                      <FormattedMessage
                        id="ready-size-classified"
                        defaultMessage="Clasificado"
                      />
                    </p>
                    <p className="rs-habilitado-btn-info">
                      <FormattedMessage
                        id="ready-size-classified-subtitle"
                        defaultMessage="Es un producto que tiene codigo de guía, fit por lo tanto
                        esta listo para calcular talles."
                      />
                    </p>
                  </div>
                  <div>
                    {/* <h4 className="rs-habilitado-btn-h4">Tene en cuenta que:</h4> */}

                    <p className="rs-habilitado-btn-info-alt">
                      <FormattedMessage
                        id="ready-size-habilitado-btn-info-alt-start"
                        defaultMessage="Un producto comienza "
                      />
                      <span className="deshabilitado">
                        <FormattedMessage
                          id="ready-size-habilitado-btn-info-alt-deshabilitado"
                          defaultMessage="deshabilitado"
                        />
                      </span>
                      <FormattedMessage
                        id="ready-size-habilitado-btn-info-alt-middle"
                        defaultMessage=", una vez "
                      />
                      <span className="clasificado">
                        <FormattedMessage
                          id="ready-size-habilitado-btn-info-alt-clasificado"
                          defaultMessage="clasificado"
                        />
                      </span>
                      <FormattedMessage
                        id="ready-size-habilitado-btn-info-alt-end"
                        defaultMessage=", este se puede "
                      />
                      <span className="desactivar">
                        <FormattedMessage
                          id="ready-size-habilitado-btn-info-alt-desactivar"
                          defaultMessage="desactivar"
                        />
                      </span>
                      <FormattedMessage
                        id="ready-size-habilitado-btn-info-alt-final"
                        defaultMessage=" momentáneamente."
                      />
                    </p>
                    <div className="ms-modalintro-active-buttons-container">
                      <div className="ms-modalintro-active-title-sort">
                        <p>
                          <FormattedMessage
                            id="ms-table-column-enabled"
                            defaultMessage="Habilitado"
                          />
                        </p>
                        <img
                          className="ms-modalintro-active-title-sort-image"
                          src="img/ms-table-sort.png"
                          alt="sortimage"
                        />
                      </div>
                      <div className="ms-modalintro-active-buttons-image">
                        <img
                          src="img/table-buttons-img-alt-hor.png"
                          alt="activebuttons"
                        />
                      </div>
                    </div>
                    {/* <img
                      src="img/table-buttons-alt-img-alt-hor.png"
                      alt="altbtn-enabled"
                      className="rs-tristate-check"
                    /> */}
                  </div>
                </div>
              </div>
              {/* <button className="modal-intro-button-nobg" onClick={handleExit}>
                <FormattedMessage
                  id="ready-size-close"
                  defaultMessage="Salir"
                />
              </button>
              <div className="modal-intro-dots">
                <span className="dot" onClick={() => handleDotClick(2)}></span>
                <span
                  className={step === 3 ? "active-dot" : "dot"}
                  onClick={() => handleDotClick(3)}
                ></span>
                <span className="dot" onClick={() => handleDotClick(4)}></span>
              </div> */}
              <button
                className="ms-modal-intro-button-bg-last"
                onClick={handleExit}
              >
                <FormattedMessage
                  id="ready-size-ms-begin"
                  defaultMessage="Comenzar"
                />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalIntroMs;
